"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Notification_1 = require("../../Notification");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var SupportPortalTemplates_1 = require("../../../SupportPortalTemplates");
var operators_1 = require("rxjs/operators");
var ShowAllCardsAction = /** @class */ (function (_super) {
    __extends(ShowAllCardsAction, _super);
    function ShowAllCardsAction(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCustomerCardsTableRows = function (customerCards) {
            return customerCards.map(function (customerCard, index) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: customerCard.cardNumberObfuscated }), (0, jsx_runtime_1.jsx)("td", { children: customerCard.cardType }), (0, jsx_runtime_1.jsxs)("td", { children: [customerCard.expiryMonth, "/", customerCard.expiryYear] }), (0, jsx_runtime_1.jsx)("td", { children: customerCard.lastUsed == null ? "Card is not used yet" : SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(customerCard.lastUsed) })] }, index)); });
        };
        _this.toggleAllCustomerCardsModal = function () {
            if (!_this.state.dataLoaded) {
                _this.getData();
            }
            _this.setState(function (prevState) { return ({
                showAllCards: !prevState.showAllCards
            }); });
        };
        _this.state = {
            showAllCards: false,
            dataLoaded: false
        };
        return _this;
    }
    ShowAllCardsAction.prototype.getData = function () {
        var _this = this;
        if (this.props.customerId) {
            this.supportPortalService
                .getCustomerCards(this.props.customerId)
                .pipe((0, operators_1.finalize)(function () { return _this.setState({ dataLoaded: true }); })).subscribe(function (customerCards) {
                _this.setState({ customerCards: customerCards });
            });
        }
    };
    ShowAllCardsAction.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("i", { title: "Show all customer cards", className: "icon-button far fa-credit-card ml-2", id: "showAllCustomerCards", onClick: this.toggleAllCustomerCardsModal }), (0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showAllCards, hide: this.toggleAllCustomerCardsModal, title: "Customer registered cards", body: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: !this.state.showAllCards }), this.state.showAllCards &&
                                (this.state.customerCards !== undefined ? ((0, jsx_runtime_1.jsxs)("table", { className: "table table-hover table-sm table-bordered", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { className: "table-active", children: [(0, jsx_runtime_1.jsx)("th", { children: "Card number" }), (0, jsx_runtime_1.jsx)("th", { children: "Card type" }), (0, jsx_runtime_1.jsx)("th", { children: "Expiry date" }), (0, jsx_runtime_1.jsx)("th", { children: "Last used at" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderCustomerCardsTableRows(this.state.customerCards) })] })) : (0, jsx_runtime_1.jsx)("h4", { children: "Cards not found" }))] }), style: {
                        margin: "0",
                        maxWidth: "100%",
                        width: "100%"
                    } })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], ShowAllCardsAction.prototype, "supportPortalService", void 0);
    return ShowAllCardsAction;
}(React.Component));
exports.default = ShowAllCardsAction;
//# sourceMappingURL=ShowAllCardsAction.js.map